export default __webpack_public_path__ + "static/media/statistics3.0f7cf3ed.jpg";